<template>
	<div class="content-wrapper">
		<!-- Content -->

		<div class="container flex-grow-1 container-p-y">

			<div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
				<div class="d-flex flex-column justify-content-center">
					<h4 class="mb-1">Liste de vos salariés</h4>
					<p class="mb-0">Vous pouvez créer tous vos salariés ici, vous pourrez ensuite leur assigner une formation</p>
				</div>
				<div class="d-flex align-content-center flex-wrap gap-4">
					<router-link to="/employees/create">
						<button type="submit" class="btn btn-primary">Créer un salarié</button>
					</router-link>
				</div>
			</div>

			<div class="col-lg-12">
				<div class="card">
					<div class="card h-100">
						<div class="card-body pb-0">
							<form class="dt_adv_search">
								<div class="row">
									<div class="col-12">
										<div class="row g-5">
											<div class="col-12 col-sm-12 col-lg-12">
												<div class="form-floating form-floating-outline">
													<input
														type="text"
														class="form-control dt-input dt-full-name"
														data-column="1"
														placeholder="Phillipe Porte"
														data-column-index="0"
														v-model="search"
														@input="applyFilters"
														autocomplete="off"
													/>
													<label>Recherche par nom, prenom</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
						<div class="table-responsive">
							<table class="table table-borderless">
								<thead>
									<tr class="border-bottom">
										<th class="bg-transparent fs-xsmall">#</th>
										<th class="bg-transparent fs-xsmall">Nom</th>
										<th class="bg-transparent fs-xsmall">Email</th>
										<th class="bg-transparent fs-xsmall">Société</th>
										<th class="bg-transparent fs-xsmall">Role</th>
										<th class="bg-transparent fs-xsmall">Formations</th>
										<th class="bg-transparent fs-xsmall">Actions</th>
									</tr>
								</thead>
								<tbody class="table-border-bottom-0">
									<tr v-for="(employee, index) in employees" :key="index">
										<td>
											<div class="avatar avatar">
												<span class="avatar-initial rounded-circle bg-label-primary">{{ generateInitials(employee) }}
												</span>
											</div>
										</td>
										<td>
											<span class="fw-medium">{{ employee.firstName }} {{ employee.lastName }}</span>
										</td>
										<td>
											<span class="fw-medium">{{ employee.email }} </span>
										</td>
										<td>
											<span class="fw-medium">{{ employee.company.name }} </span>
										</td>
										<td>
											<span class="badge rounded-pill bg-label-danger me-1" v-if="employee.role === 'manager' && !employee.isSubCompany">
												Manager
											</span>
											<span class="badge rounded-pill bg-label-danger me-1" v-else-if="employee.role === 'manager' && employee.isSubCompany">
												Manager de filiale
											</span>
											<span class="badge rounded-pill bg-label-primary me-1" v-else>
												Stagiaire
											</span>
										</td>
										<td>
											<span class="badge rounded-pill bg-label-primary me-1" v-if="employee.trainings > 0">
												{{ employee.trainings }}
											</span>
											<span class="badge rounded-pill bg-label-secondary me-1" v-else>
												{{ employee.trainings }}
											</span>
										</td>
										<td>
											<a href="javascript:void(0);" class="btn btn-sm btn-icon btn-text-secondary rounded-pill me-1 waves-effect waves-light" data-bs-toggle="tooltip" title="Voir le profil" @click="goToProfile(employee._id)">
												<i class="ri-edit-2-line ri-22px"></i>
											</a>
											<a href="javascript:void(0);" class="btn btn-sm btn-icon btn-text-secondary rounded-pill me-1 waves-effect waves-light" @click="deleteEmployee(employee._id)" v-if="employee.trainings === 0" data-bs-toggle="tooltip" title="Supprimer">
												<i class="ri-delete-bin-6-line ri-22px"></i>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="row mt-5" v-if="pagination.totalEntries > 5">
							<div class="col-sm-12 col-md-6">
								<div class="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite" style="padding-left: 15px;margin: 10px;">
									Total de {{ pagination.totalEntries }} salariés
								</div>
							</div>
							<div class="col-sm-12 col-md-6 d-flex justify-content-end" style="padding-right: 40px;">
								<div class="pagination-container">
									<ul class="pagination">
										<!-- Bouton Précédent -->
										<li :class="['page-item', { disabled: pagination.page === 1 }]" @click="changePage(pagination.page - 1)">
											<a class="page-link">
												<i class="ri-arrow-left-s-line"></i>
											</a>
										</li>

										<!-- Pages dynamiques (affichage par groupe de 3) -->
										<li v-for="page in visiblePages" :key="page" :class="['page-item', { active: page === pagination.page }]" @click="changePage(page)">
											<a class="page-link">{{ page }}</a>
										</li>

										<!-- Bouton Suivant -->
										<li :class="['page-item', { disabled: pagination.page + 3 > pagination.totalPages }]" @click="changePage(pagination.page + 1)">
											<a class="page-link">
												<i class="ri-arrow-right-s-line"></i>
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- / Content -->

		<div class="content-backdrop fade"></div>
	</div>
</template>

<script>
import HTTP from "@/axios";

import { Tooltip } from 'bootstrap'

export default {
	name: "EmployeeList",

	data() {
		return {
			employees: [],
			search: null,
			pagination: {
				page: 1,
				limit: 10, // Nombre d'éléments par page
				totalEntries: 0,
				totalPages: Math.ceil(99 / 10) // Calculé dynamiquement
			}
		};
	},

	computed: {
		visiblePages() {
			const start = Math.floor((this.pagination.page - 1) / 3) * 3 + 1;
			const end = Math.min(start + 2, this.pagination.totalPages);
			return Array.from({ length: end - start + 1 }, (_, i) => start + i);
		},
		// Calcul du premier élément affiché
		startEntry() {
			return (this.pagination.page - 1) * this.pagination.limit + 1;
		},
		// Calcul du dernier élément affiché
		endEntry() {
			return Math.min(this.pagination.page * this.pagination.limit, this.pagination.totalEntries);
		}
	},

	methods: {
		goToProfile(employeeId) {
			this.$router.push(`/employees/profile/${employeeId}`);
		},

		async deleteEmployee(employeeId) {
			if (!confirm("Êtes vous sur de vouloir supprimer ce compte? Cette action est irreversible."))
				return;

			try {
				await HTTP.delete("/company/employees/" + employeeId);
				this.fetchEmployees();
			} catch (error) {
				// Gestion des erreurs
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},

		async fetchEmployees() {
			try {
				const params = {
					page: this.pagination.page,
					limit: this.pagination.limit,
					search: this.search || undefined,
				};

				// Appel API avec les filtres et pagination
				const response = await HTTP.get("/company/employees", { params });

				// Mise à jour des données
				this.employees = response.data.employees;

				this.pagination.totalEntries = response.data.pagination.totalEntries;
				this.pagination.totalPages = response.data.pagination.totalPages;

				const tooltipTriggerList = this.$el.querySelectorAll('[data-bs-toggle="tooltip"]')
				tooltipTriggerList.forEach((el) => {
					new Tooltip(el)
				})
			} catch (error) {
				// Gestion des erreurs
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},

		generateInitials(employee) {
			if (!employee) return '';

			const firstInitial = employee.firstName ? employee.firstName.trim().charAt(0).toUpperCase() : '';
			const lastInitial = employee.lastName ? employee.lastName.trim().charAt(0).toUpperCase() : '';

			return `${firstInitial}${lastInitial}`;
		},

		// Méthode pour mettre à jour la page et relancer la recherche
		changePage(newPage) {
			if (newPage > 0 && newPage <= this.pagination.totalPages) {
				this.pagination.page = newPage;
				this.fetchEmployees(); // Charge les nouvelles données
			}
		},
		// Méthode déclenchée par les inputs de recherche
		applyFilters() {
			this.pagination.page = 1; // Réinitialiser à la première page
			this.fetchEmployees();
		}
	},

	async mounted() {
		await this.fetchEmployees();

		const tooltipTriggerList = this.$el.querySelectorAll('[data-bs-toggle="tooltip"]')
		tooltipTriggerList.forEach((el) => {
			new Tooltip(el)
		})
	}
};
</script>

<style scoped>
/* Ajoutez des styles spécifiques à la page Dashboard */
.dashboard {
	padding: 1rem;
}

.card-title {
	font-size: 1.2rem;
}

.card-text {
	margin: 0;
}
</style>
